import * as React from 'react';

interface OrbitMaintenanceBannerProps {
  message?: string | null;
  className?: string;
}

const OrbitMaintenanceBanner: React.FC<OrbitMaintenanceBannerProps> = ({
  message,
  className = '',
}) => {
  const normalizedMessage = String(message || '').trim();

  if (!normalizedMessage) {
    return null;
  }

  return (
    <div
      className={`border-b border-[#F7B27A] bg-[#FFF7ED] px-4 py-3 ${className}`.trim()}
      role="status"
      aria-live="polite"
    >
      <div className="flex items-start gap-2.5">
        <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#FDBA74] text-[11px] font-bold text-[#7C2D12]">
          !
        </div>
        <div className="min-w-0">
          <p className="text-[12px] font-semibold leading-5 text-[#9A3412]">Ask Indie maintenance notice</p>
          <p className="mt-0.5 whitespace-pre-wrap text-[12px] leading-5 text-[#7C2D12]">{normalizedMessage}</p>
        </div>
      </div>
    </div>
  );
};

export default OrbitMaintenanceBanner;

